import { render, staticRenderFns } from "./2.vue?vue&type=template&id=d735b8fa&scoped=true&"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=d735b8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d735b8fa",
  null
  
)

export default component.exports